const EVENT_INITIATE_CHECKOUT = 'event-initiate-checkout';

const initiateCheckoutEventTrigger = () => {
	const checkoutStep = document.querySelector('[data-ec-checkout-step]');
	if (checkoutStep && checkoutStep.dataset.ecCheckoutStep == 1) {
		const event = new CustomEvent(EVENT_INITIATE_CHECKOUT);
		document.dispatchEvent(event);
	}
};

export {EVENT_INITIATE_CHECKOUT, initiateCheckoutEventTrigger};